import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, withCtx as _withCtx, createSlots as _createSlots, createCommentVNode as _createCommentVNode, TransitionGroup as _TransitionGroup } from "vue"

import { INotificationsPlugin } from '@/plugins/notifications/@types'
import '@/components/ui/notifications/TheNotifications/style.scss'

import { inject } from 'vue'

import ThePush from '@/components/ui/notifications/ThePush/ThePush.vue'
import TheSnackbar from '@/components/ui/notifications/TheSnackbar/TheSnackbar.vue'
// import TheNotification from '@/plugins/notificationsPlugin/components/TheNotification.vue'
// import notifications from '@/plugins/notifications'


export default /*#__PURE__*/_defineComponent({
  __name: 'TheNotifications',
  setup(__props) {

const { 
  pushes, 
  snackbars,
  removePush,
  removeSnackbar
} = inject('notifications-plugin') as INotificationsPlugin

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_TransitionGroup, {
    name: "notifications",
    tag: "div",
    class: "notifications"
  }, {
    default: _withCtx(() => [
      (_unref(pushes).length)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(pushes), (item) => {
            return (_openBlock(), _createBlock(ThePush, {
              key: `notification-${item.id}`,
              id: item.id,
              type: item.type,
              message: item.message,
              footer: item.footer,
              "show-close": item.showClose,
              duration: item.duration,
              onClose: ($event: any) => (_unref(removePush)(item.id))
            }, _createSlots({ _: 2 }, [
              (item.slots?.footer)
                ? {
                    name: "footer",
                    fn: _withCtx(() => [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(item.slots.footer)))
                    ]),
                    key: "0"
                  }
                : undefined
            ]), 1032, ["id", "type", "message", "footer", "show-close", "duration", "onClose"]))
          }), 128))
        : _createCommentVNode("", true),
      (_unref(snackbars).length)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(snackbars), (item) => {
            return (_openBlock(), _createBlock(TheSnackbar, {
              key: `snackbar-${item.id}`,
              id: item.id,
              message: item.message,
              duration: item.duration,
              vertical: item.vertical,
              action: item.action,
              "show-close": item.showClose,
              onClose: ($event: any) => (_unref(removeSnackbar)(item.id))
            }, null, 8, ["id", "message", "duration", "vertical", "action", "show-close", "onClose"]))
          }), 128))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})